export const sectionElementId = key => `location-section-${key}`;

export const DEFAULT_SECTIONS_OPEN = {
    general: true,
    contact: true,
    socialLinks: true,
    address: true,
    additionalInfo: true,
    businessHours: true,
    specialHours: true,
    appearance: true,
    paymentMethods: true,
    services: true,
    localDirectories: true,
};
